module.exports = __webpack_public_path__ + "static/media/dog-rottweiler.b9f35ba3.png";